import request from '@/middleware/request'

const getUser = () => {
  return request({
    url: '/users',
    method: 'get'
  })
}

const getEmail = () => {
  return request({
    url: '/users/emails',
    method: 'get'
  })
}

const createUser = data => {
  return request({
    url: '/users',
    method: 'post',
    data
  })
}

const updateUser = (id, data) => {
  return request({
    url: `/users/${id}`,
    method: 'patch',
    data
  })
}

const hasOneAdminActive = params => {
  let url = '/users'
  let i = 0

  for (const property in params) {
    if (i === 0) {
      url = url + `?${property}=${params[property]}`
    } else {
      url = url + `&${property}=${params[property]}`
    }
    i = i + 1
  }

  return request({
    url: url,
    method: 'get'
  })
}

// const updateProfile = (id, data) => {
//   return request({
//     url: `/users/update-profile/${id}`,
//     method: 'patch',
//     data
//   })
// }

const changePassword = (id, data) => {
  return request({
    url: `/users/change-password/${id}`,
    method: 'patch',
    data
  })
}

const getAutoPickUpCapacity = () => {
  return request({
    url: '/users/auto-pickup-capacity',
    method: 'get'
  })
}

const getAvatar = userId => {
  return request({
    url: `/users/${userId}/avatar`,
    method: 'get'
  })
}

export default {
  getUser,
  getEmail,
  createUser,
  updateUser,
  hasOneAdminActive,
  changePassword,
  getAutoPickUpCapacity,
  getAvatar
}
